module.exports = __webpack_public_path__ + "img/1530633890.b6ca2000.jpg";